import React from "react";

import {
    FormEnabler,
    ValidatedForm,
    MInput,
    MTextArea,
    MToggle,
    MSelect,
    MFile
} from "components/forms";

import {
    payloadBuilder,
    invalidFieldsMapper,
    networkErrorHelper,
    notNullObjectBuilder,
    adminService,
    stringHelper
} from "libs";

import {
    Card,
    CardBody,
} from 'design-react-kit';

import ReactHtmlParser from 'react-html-parser';

export class AdminLibraryBook extends ValidatedForm {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            ...this.emptyFields,
            defaultValues: { ...this.emptyFields },
            formActive: parseInt(this.props.idLibraryBook) > 0 ? false : true,
            forceUpdateParentListCategory: 0,
            forceUpdateParentListAuthor: 0
        };

        // bind event handler to invoke it from child component
        this.onChange = this.onChange.bind(this);
    }

    //--- ---    

    emptyFields = {
        categoryId: 0,
        authorId: 0,
        isVisible: false,
        isFeatured: false,
        title: '',
        description: '',
        year: '',
        printLength: '',
        slug: '',
        pdfUrl: (parseInt(this.props.idLibraryBook) > 0) ? parseInt(this.props.idLibraryBook) : 0,
        coverUrl: (parseInt(this.props.idLibraryBook) > 0) ? parseInt(this.props.idLibraryBook) : 0
    }

    parentListCategory = []
    parentListAuthor   = []


    FIELDS_GROUP = [   
        [
            {
                id: "categoryId",
                name: "categoryId",
                field: "categoryId",
                label: "Categoria",
                payload: { options: this.parentListCategory },
                component: MSelect,
                className: "col-md-6 mt-2"
            },
            {
                id: "authorId",
                name: "authorId",
                field: "authorId",
                label: "Autore",
                payload: { options: this.parentListAuthor },
                component: MSelect,
                className: "col-md-6 mt-2"
            }
        ],
        [
            {
                id: "isVisible",
                name: "isVisible",
                field: "isVisible",
                label: "Visibile",
                component: MToggle,
                className: "col-md-3"
            },
            {
                id: "isFeatured",
                name: "isFeatured",
                field: "isFeatured",
                label: "in Primo Piano",
                component: MToggle,
                className: "col-md-3"
            }
        ],
        [
            {
                id: "title",
                field: "title",
                label: "titolo",
                component: MInput,
                type: "text",                
                onChange: (_, value) => this.onChangeMakeSlug(_, value), 
                className: "col-md-12"
            }
        ],
        [
            {
                id: "year",
                field: "year",
                label: "Anno pubblicazione",
                component: MInput,
                className: "col-md-3"
            },
            {
                id: "printLength",
                field: "printLength",
                label: "n° pagine",
                component: MInput,
                className: "col-md-3"
            }
        ],
        [
            {
                id: "description",
                field: "description",
                label: "Descrizione",
                component: MTextArea,
                rows: 5,
                className: "col-md-12"
            }
        ],
        [
            {
                id: "slug",
                field: "slug",
                label: "URL (slug)",
                component: MInput,
                type: "text",
                className: "col-md-12 mt-4"
            }
        ],
        [
            {
                id: "pdfUrl",
                field: "pdfUrl",
                label: "Libro (pdf)",
                infoText: "Caricare il libro in formato pdf",
                component: MFile,
                config: { endPoint: '/admin/library-book-pdf', mandatory:false, fieldName: 'pdfUrl', maxFiles: 1 },
                className: "col-md-12"
            },
            {
                id: "coverUrl",
                field: "coverUrl",
                label: "Copertina",
                infoText: "Caricare la copertina del Libro",
                component: MFile,
                config: { endPoint: '/admin/library-book-cover', mandatory:false, fieldName: 'coverUrl', maxFiles: 1 },
                className: "col-md-12"
            }
        ]
    ];

    ERROR_MESSAGES = {
        fullName: "Titolo non valido (max 255 caratteri)",
        slug: "Slug (URL) non valido"
    };

    validation = {
        titolo: value => /^[a-z0-9:!?.,-/àèéì’'òù,/\s"]+$/i.test(value) && value.length <= 255,
        slug: value => value.length>0 && value.length <= 255,
    };

    
    //--- ---

    componentDidMount(){
        this.loadRemote();
        
        // load list category and popolate MSelect
        this.loadRemoteParentCategory();
        
        // load list author and popolate MSelect
        this.loadRemoteParentAuthor();
    }

    //--- ---
    loadRemoteParentCategory(){       
        let filter = { searchFilter:{ isVisible: true } };
        
        adminService.loadAllLibraryCategory(filter).then(({ data }) => {
            this.parentListCategory.push({ label: 'Seleziona', value: 0 });
            Object.entries(data.payload.libraryCategories).forEach(([key, val]) => {
                this.parentListCategory.push(
                    {
                        label: ReactHtmlParser(val.name),
                        value: val.id
                    }
                )
            });

            this.setState({
                forceUpdateParentListCategory: Math.floor((Math.random() * 1000) + 1)
            })
        })
        .catch(error => {
            console.log(error);
            if (!networkErrorHelper.is404(error)) {
                networkErrorHelper.notify(error);
            }
        });
    }//loadRemoteParentCategory

    loadRemoteParentAuthor(){       
        let filter = { searchFilter:{ isVisible: true } };
        
        adminService.loadAllLibraryAuthor(filter).then(({ data }) => {
            this.parentListAuthor.push({ label: 'Seleziona', value: 0 });
            Object.entries(data.payload.libraryAuthors).forEach(([key, val]) => {
                this.parentListAuthor.push(
                    {
                        label: ReactHtmlParser(val.fullName),
                        value: val.id
                    }
                )
            });

            this.setState({
                forceUpdateParentListAuthor: Math.floor((Math.random() * 1000) + 1)
            })
        })
        .catch(error => {
            console.log(error);
            if (!networkErrorHelper.is404(error)) {
                networkErrorHelper.notify(error);
            }
        });
    }//loadRemoteParentAuthor
    //--- ---

    onChangeMakeSlug = (_, value) => {
        const ret = stringHelper.makeSlug(value);
       
        this.setState({
            slug: ret,
            defaultValues:{
                ...this.state.defaultValues,
                slug: ret
            }
        })
    }
    
    loadRemote(additionalState = {}) {
        //--- prevent loadRemote when not required ---
        if (parseInt(this.props.idLibraryBook) <= 0) {
            return false;
        }

        let filter = {
            searchFilter:{
              id: parseInt(this.props.idLibraryBook)
            }
        }

        adminService.loadAllLibraryBook(filter)
            .then(({ data }) => {
                const defaultValues = notNullObjectBuilder(
                    this.emptyFields,
                    data.payload.libraryBooks,
                    {
                        pdfUrl: data.payload.libraryBooks.id,
                        coverUrl: data.payload.libraryBooks.id
                    }
                );

                const newState = {
                    defaultValues,
                    ...additionalState,
                    loading:false,
                };
                
                this.setState(newState);
            })
            .catch(error => {
                networkErrorHelper.notify(error);
                console.log(error);
            });
    }//loadRemote

    onBackPage = () => {
        window.history.back();
    }//onBackPage

    saveRemote = () => {
        let payload = payloadBuilder(this.state);
       
        if (parseInt(this.props.idLibraryBook) > 0) {
            adminService.updateLibrarybook(payload).then(
                (result) => {
                    this.onBackPage();
                }
            )
            .catch(errors => {
                if (networkErrorHelper.is422(errors)) {
                    const newState = invalidFieldsMapper(
                        errors,
                        this.state,
                        this.ERROR_MESSAGES
                    );
                    this.setState({ ...newState });
                } else {
                    networkErrorHelper.notify(errors);
                }
            });

        } else {

            adminService.insertLibrarybook(payload).then(
                (result) => {
                    this.onBackPage();
                }
            )
            .catch(errors => {
                if (networkErrorHelper.is422(errors)) {
                    const newState = invalidFieldsMapper(
                        errors,
                        this.state,
                        this.ERROR_MESSAGES
                    );
                    this.setState({ ...newState });
                } else {
                    networkErrorHelper.notify(errors);
                }
            });
        }
    }//saveRemote

    //--- ---

    render() {
        
        if (this.loading){
            return (<></>);
        }

        let { formActive, defaultValues } = this.state;

        if (parseInt(this.props.idLibraryBook) === 0) {
            formActive = true;
        }

        const { formValid, code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);

        return (
            <>
                <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
                    <div className="flag-icon" />
                    <CardBody tag="div">
                        <form className="user" id="courseform">
                            {code}
                        </form>

                        <div className="mt-4">
                            <FormEnabler
                                onSubmit={this.onSubmit}
                                onCancel={parseInt(this.props.idLibraryBook) > 0 ? this.onCancel : this.onBackPage}
                                onToggle={this.toggleForm}
                                isFormActive={formActive}
                                disableSave={!formValid}
                            />
                        </div>
                    </CardBody>
                </Card>               
            </>
        );
    }
}
